/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../Node';
import { IVisitor } from '../../visitors/IVisitor';

/**
 * Constructor.
 * @class
 * @extends Node
 * @author eric.wittmann@gmail.com
 */
export abstract class SecurityRequirement extends Node {
    /*private*/ _items : any = <any>({});

    public constructor() {
        super();
    }

    /**
     * Gets the names of all the security requirements.
     * @return {string[]}
     */
    public getSecurityRequirementNames() : Array<string> {
        let rval : Array<string> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* keySet */Object.keys(this._items));
        return rval;
    }

    /**
     * Gets the scopes defined for this security requirement.  This is only valid if the
     * type of security is oauth2.
     * @param {string} name
     * @return {string[]}
     */
    public getScopes(name : string) : Array<string> {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this._items, name);
    }

    /**
     * Adds a security requirement item.
     * @param {string} name
     * @param {string[]} scopes
     */
    public addSecurityRequirementItem(name : string, scopes : Array<string>) {
        if(scopes == null) {
            scopes = /* emptyList */[];
        }
        /* put */(this._items[name] = scopes);
    }

    /**
     * Removes a single security requirement item (reference to an existing security scheme)
     * by scheme name and returns the array of scopes previously mapped to the scheme name.
     * @param {string} name
     * @return {string[]}
     */
    public removeSecurityRequirementItem(name : string) : Array<string> {
        return /* remove */(map => { let deleted = this._items[name];delete this._items[name];return deleted;})(this._items);
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        visitor.visitSecurityRequirement(this);
    }
}
SecurityRequirement["__class"] = "io.apicurio.datamodels.core.models.common.SecurityRequirement";
SecurityRequirement["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




